import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import { fetchSigninOptions } from 'features/signin-options/reducers/recordsSlice';

import { defaultSigninOptionSelector } from 'features/signin-options/selectors';

export const SigninOptionsContext = createContext(null);

export const SigninOptionsContextProvider = ({ children }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchSigninOptions());
    }, []);

    const defaultOption = useSelector((state) =>
        defaultSigninOptionSelector(state)
    );

    return (
        <SigninOptionsContext.Provider value={{ defaultOption }}>
            {children}
        </SigninOptionsContext.Provider>
    );
};

SigninOptionsContextProvider.propTypes = {
    children: PropTypes.object,
};
